<script setup lang="ts">
import type {
  Attachment,
  FineUploaderUpload,
} from '@/models/current-student-advanced-standing-form/api'
import FineUploaderModalUpload from '@/components/current-student-advanced-standing-form/upload/FineUploaderModalUpload.vue'
import SavedAttachmentTable from '@/components/current-student-advanced-standing-form/upload/SavedAttachmentTable.vue'

defineProps<{
  savedAttachments: Attachment[]
  courseAttachmentDeleteIds: number[]
  showCourseFineUploader: boolean
  visibleCourseNewAttachments: FineUploaderUpload[]
  courseUploadDropActive: boolean
  courseUploadAlertMessage: string
  uploadThumbnailUrl: (attachment: FineUploaderUpload) => string
}>()

const emit = defineEmits<{
  stageCourseAttachmentDelete: [attachment: Attachment]
  courseUploadDragEnter: [event: DragEvent]
  courseUploadDragOver: [event: DragEvent]
  courseUploadDragLeave: [event: DragEvent]
  courseUploadDrop: [event: DragEvent]
  triggerUploadInput: [event: MouseEvent]
  uploadButtonKeydown: [event: KeyboardEvent]
  uploadButtonHover: [event: MouseEvent, hover: boolean]
  uploadButtonFocus: [event: FocusEvent, focused: boolean]
  courseAttachmentSelected: [event: Event]
  cancelStagedUpload: [attachment: FineUploaderUpload]
  retryCourseAttachment: [attachment: FineUploaderUpload]
  deleteStagedCourseAttachment: [attachment: FineUploaderUpload]
  closeCourseUploadAlert: []
}>()
</script>

<template>
            <div class="form-field">
              <label>Attachments</label>
              <p>Please note, only official academic transcripts will be accepted</p>
              <SavedAttachmentTable
                tbody-id="courseAttachmentUploadTable"
                :attachments="savedAttachments"
                :deleted-attachment-ids="courseAttachmentDeleteIds"
                @stage-delete="emit('stageCourseAttachmentDelete', $event)"
              />
            </div>

            <div class="form-field">
              <FineUploaderModalUpload
                uploader-id="courseAttachmentFineUploader"
                :visible="showCourseFineUploader"
                :attachments="visibleCourseNewAttachments"
                :drop-active="courseUploadDropActive"
                :alert-message="courseUploadAlertMessage"
                :upload-thumbnail-url="uploadThumbnailUrl"
                @drag-enter="emit('courseUploadDragEnter', $event)"
                @drag-over="emit('courseUploadDragOver', $event)"
                @drag-leave="emit('courseUploadDragLeave', $event)"
                @drop="emit('courseUploadDrop', $event)"
                @trigger-upload-input="emit('triggerUploadInput', $event)"
                @upload-button-keydown="emit('uploadButtonKeydown', $event)"
                @upload-button-hover="(event, hover) => emit('uploadButtonHover', event, hover)"
                @upload-button-focus="(event, focused) => emit('uploadButtonFocus', event, focused)"
                @file-selected="emit('courseAttachmentSelected', $event)"
                @cancel-staged-upload="emit('cancelStagedUpload', $event)"
                @retry-upload="emit('retryCourseAttachment', $event)"
                @delete-staged-upload="emit('deleteStagedCourseAttachment', $event)"
                @close-alert="emit('closeCourseUploadAlert')"
              />
            </div>
</template>
